export default __webpack_public_path__ + "static/media/build4.5a54b237.png";